import React from "react";
import DevicePlaces  from "../modules/DevicePlaces/DevicePlaces";
export default function DevicePlacesPage() {
  return <DevicePlaces />;
}
